import { FabricUser } from 'src/components/bbc-atlaskit-editor';
import { User as BBUser } from 'src/components/types';
import {
  getAvatarUrl,
  getName,
  getProfileUrl,
} from 'src/components/user-profile/src/utils';

export function toFabricUser(user: Maybe<BBUser>): FabricUser {
  return {
    id: user ? user.uuid : '',
    name: getName(user),
    avatarUrl: getAvatarUrl(user) || undefined,
    profileUrl: getProfileUrl(user) || undefined,
  };
}

export function toBBUser(user: Maybe<FabricUser>): BB.User {
  return {
    uuid: (user && user.id) || '',
    display_name: (user && user.name) || '',
    nickname: (user && user.name) || '',
    type: 'user',
    links: {
      self: {
        href: '',
      },
      avatar: {
        href: (user && user.avatarUrl) || '',
      },
      html: {
        href: (user && user.profileUrl) || '',
      },
    },
  };
}
